module.exports = __webpack_public_path__ + "img/melanie-bohn.47ae5d02.jpeg";